<template>
    <div class="sub-page">
        <div class="block">
            <div class="img-sub-area" v-if="subImgListFilter.length">
                <div v-for="(sub, index) in subImgListFilter" :key="index" class="sub-item">
                    <img v-if="sub.image" :src="sub.image" alt="">
                    <div class="sub-detail" @click="goLocale(isCn?sub.cnAddress:sub.enAddress)">
                        <p :style="{textIndent:isCn?'-3em':'-57px',paddingLeft:isCn?'3em':'57px'}">
                            <span>{{lang.address}}：{{isCn?sub.cnAddress:sub.enAddress}}</span>
                            <img :src="marker" alt="">
                        </p>
                        <p v-if="sub.postCode">{{lang.postCode}}：{{sub.postcode}}</p>
                        <p>{{lang.phone}}：{{sub.phoneNumber}}</p>
                        <p v-if="sub.fax">{{lang.fax}}：{{sub.fax}}</p>
                        <p v-if="sub.website">{{lang.website}}：{{sub.website}}</p>
                    </div>
                    <h6>{{isCn?sub.cnName:sub.enName}}</h6>
                </div>
            </div>
            <div class="text-sub-area" v-if="subTextListFilter.length">
                <div v-for="(sub, index) in subTextListFilter" :key="index" class="sub-item">
                    <h6>{{isCn?sub.cnName:sub.enName}}</h6>
                    <div class="sub-detail" @click="goLocale(isCn?sub.cnAddress:sub.enAddress)">
                        <p :style="{textIndent:isCn?'-3em':'-57px',paddingLeft:isCn?'3em':'57px'}">
                            <span>{{lang.address}}：{{isCn?sub.cnAddress:sub.enAddress}}</span>
                            <i></i>
                        </p>
                        <p v-if="sub.postCode">{{lang.postCode}}：{{sub.postcode}}</p>
                        <p>{{lang.phone}}：{{sub.phoneNumber}}</p>
                        <p v-if="sub.fax">{{lang.fax}}：{{sub.fax}}</p>
                        <p v-if="sub.website">{{lang.website}}：{{sub.website}}</p>
                    </div>
                </div>
            </div>
            <div class="more-row" v-show="!isMoreSub">
                <span class="btn-more" @click="moreSub()">{{lang.spread}}</span>
            </div>
        </div>
        <Locale ref="locale"></Locale>
    </div>
</template>

<script>
import markerSrc from '@/style/map_marker.png';
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import Locale from '@/views/about/Locale.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'aboutSub',
    components: {
        Layout,
        Locale,
    },
    props: {
        cate: String,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            marker: markerSrc,
            type: this.$props.cate,
            subImgList: [],
            subImgListFilter: [],
            subTextList: [],
            subTextListFilter: [],
            isMoreSub: false,
            showAddress: false,
            isMap: true,
            showMapAddress: '',
            showPhotoSrc: '',
        };
    },
    watch: {
        type() {
            this.renderSub();
        },
    },
    mounted() {
        this.renderSub();
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        renderSub() {
            this.isMoreSub = false;
            const self = this;
            const params = {
                pageSize: 1000,
                companyTypeId: this.type,
            };
            ajax.get('/web/about_us/company_list.json', { ...params }).then((res) => {
                const subData = res.dataList;
                self.subImgList = subData.filter(v => (!!v.image));
                self.subImgListFilter = subData.filter(v => (!!v.image)).slice(0, 6);
                self.subTextList = subData.filter(v => (!v.image));
                self.subTextListFilter = subData.filter(v => (!v.image)).slice(0, 3);
                self.isMoreSub = (self.subImgList.length <= 6 && self.subTextList.length <= 3);
                self.moreSub();
                self.$forceUpdate();
            }).catch(() => {});
        },
        moreSub() {
            this.isMoreSub = true;
            this.subImgListFilter = this.subImgList;
            this.subTextListFilter = this.subTextList;
        },
        goLocale(address) {
            // this.$refs.locale.open(address);
        },
    },
};
</script>
<style lang="less" scoped>
    .block {
        border-top: 8px solid #F8FAF9;
        background: #fff;
        padding: 15px;
        .block-title{
            font-size:20px;
            font-weight:600;
            color:rgba(74,74,74,1);
            line-height:20px;
            text-align: center;
            position: relative;
            &::after{
                content:"";
                width:44px;
                height:4px;
                background:rgba(199,31,75,1);
                position: absolute;
                bottom: -12px;
                left: 50%;
                margin-left: -22px;
            }
        }
    }
    .img-sub-area {
        display: flex;
        width: 1200px;
        margin: 24px auto 0;
        padding-bottom: 38px;
        border-bottom: 1px solid #F8FAF9;
        justify-content: flex-start;
        flex-wrap: wrap;
        .sub-item {
            position: relative;
            margin-right: 30px;
            flex: 0 0 380px;
            & > img {
                display: block;
                width: 380px;
                height: 235px;
            }
            h6 {
                font-size: 14px;
                font-weight: 600;
                word-break: break-word;
                text-align: center;
                line-height: 24px;
                margin-bottom: 20px;
            }
            .sub-detail {
                position: absolute;
                left: 0;
                top: 0;
                width: 380px;
                height: 235px;
                overflow: hidden;
                background: rgba(199,31,75,0.85);
                color: #fff;
                display: none;
                & p > img {
                    display: inline-block;
                    margin-left: 12px;
                    width: 18px;
                    height: 18px;
                }
            }
            &:hover {
                .sub-detail {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    p {
                        display: flex;
                        align-items: flex-start;
                        line-height: 18px;
                        font-size: 12px;
                        width: 332px;
                        padding-left: 3em;
                        text-indent: -3em;
                        word-break: break-word;
                    }
                }
            }
            &:nth-child(3n) {
                margin-right: 0;
            }
        }
    }
    .text-sub-area {
        display: flex;
        width: 1200px;
        margin: 24px auto 32px;
        justify-content: flex-start;
        flex-wrap: wrap;
        .sub-item {
            margin-top: 30px;
            margin-right: 30px;
            flex: 0 0 380px;
            h6 {
                font-size: 14px;
                font-weight: 600;
                word-break: break-word;
                text-align: center;
                line-height: 24px;
                margin-bottom: 20px;
            }
            .sub-detail {
                margin-top: 24px;
                width: 380px;
                overflow: hidden;
                color: #4A4A4A;
                p {
                    position: relative;
                    display: flex;
                    align-items: flex-start;
                    line-height: 18px;
                    font-size: 12px;
                    width: 332px;
                    padding-left: 3em;
                    text-indent: -3em;
                    word-break: break-word;
                    i {
                        position: absolute;
                        display: inline-block;
                        margin-left: 12px;
                        width: 18px;
                        height: 18px;
                        right: -28px;
                        background: url('../../style/map_marker.png') 50% 50% no-repeat;
                        background-size: contain;
                    }
                }
            }
            &:hover {
                h6 {
                    color: #C71F4B;
                }
                p i {
                    background: url('../../style/map_marker_active.png') 50% 50% no-repeat;
                    background-size: contain;
                }
            }
            &:nth-child(3n) {
                margin-right: 0;
            }
        }
    }
    .more-row {
        padding-top: 16px;
        text-align:center;
        .btn-more {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 128px;
            height: 32px;
            line-height: 30px;
            font-size: 12px;
            color: #4A4A4A;
            border: 1px solid #C71F4B;
        }
    }
</style>
